import { AppIdentity } from '../ptfm/core/base/identity.ts';

// Per-site settings come from /env.js at runtime: the web container writes it from
// its environment (API_BASE, THEME) on start, so one build serves every site.
// Without it (local `npm run dev`) the VITE_* build-time values are used.
const RUNTIME_ENV: { API_BASE?: string; THEME?: string } = (window as any).__ENV__ || {};
const API_BASE: string = RUNTIME_ENV.API_BASE || import.meta.env.VITE_API_BASE || 'http://localhost:5500';
const THEME: string = RUNTIME_ENV.THEME || import.meta.env.VITE_THEME || 'default';

export const AppSettings = {
    authentication_url: function () { return ''; },
    server_url: function () {
        let appUrl = API_BASE;
        const activeIdentity = this.active_identity();
        if (activeIdentity) {
            if (activeIdentity.appUrl != undefined && activeIdentity.appUrl != null && activeIdentity.appUrl != '')
                appUrl = activeIdentity.appUrl;
        }
        console.log(`app url ${appUrl}`);
        return appUrl;
    },
    client_url: function () { return ''; },
    support_url: function () { return API_BASE; },
    asset_url: function () { return ''; },
    notification_url: function () {
        return 'http://localhost:3088/notificationhub';

    },
    dochub_url: function () {
        return this.server_url() + '/unidochub';

    },
    chathub_url: function () {
        return this.server_url() + '/chathub';
    },

    appstore_url: function () {
        return 'https://qa.bizgaze.com/';
    },
    appstore_sessiontoken: function () {
        return "stat 6c8ee06dfd2840a6b8f0d7770c9fd259"
    },


    theme: function () {
        return THEME;
    },
    colorScheme: function () {
        return 'default'; // Options: 'default', 'ocean', 'royal-blue'
    },
    themeMode: function () {
        return 'light';
    },
    active_form: function () {

    },
    active_identity: function (): AppIdentity | null {
        return AppIdentity.getActiveIdentity();
    },
    isdevelopement: function () {
        return true;
    },
    AuthProviders: [
        { name: 'Google', authUrl: 'https://accounts.google.com/o/oauth2/v2/auth', clientId: '' },
        { name: 'Microsoft', authUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize', clientId: '' }
    ]
};
export const ReportViewerSettings = {
    tableViewer: function () {
        return 'tabulatorviewer';
    },
    chartViewer: function () {
        return 'tabulatorviewer';
    }
};

export const MapSettings = {
    key: function () {
        return 'AIzaSyBGmahAAg3EVzAUJvttDZsjdZiJenJxGt8';
    }
};
export const WindowsSettings = {
    AccessType: function () {
        return 'Server';
    }
};
